import React from 'react'
import Button from '../../DMGComponents/Button'
import Input from '../../DMGComponents/Input'
import Spinner from '../Spinner'
import Break from '../../DMGComponents/Break'
import { searchAdminLogs } from '../../fetchData'
import toast, { Toaster } from 'react-hot-toast'

class AdminSearchLogs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            logResults: [],
            isSearching: false,
            hasSearched: false,
            currentPage: 0,
            totalCount: 0,
        }
    }

    searchLogs = (text, page) => {
        this.setState({ isSearching: true, hasSearched: true })
        searchAdminLogs(text, page, 50).then(res => {
            this.setState({
                logResults: res?.items || [],
                totalCount: res?.totalCount || 0,
                currentPage: page,
                isSearching: false,
            })
        }).catch(() => {
            toast.error('Error searching logs.')
            this.setState({ isSearching: false })
        })
    }

    handleSearch = () => {
        this.searchLogs(this.state.searchText, 0)
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') this.handleSearch()
    }

    goToPage = (page) => {
        this.searchLogs(this.state.searchText, page)
    }

    getPageButtons(currentPage, totalPages) {
        // Always show: first, last, current, 2 neighbours each side → fill with "..."
        const delta = 2
        const range = []
        const pages = []
        let prev

        for (let i = 0; i < totalPages; i++) {
            if (i === 0 || i === totalPages - 1 || (i >= currentPage - delta && i <= currentPage + delta)) {
                range.push(i)
            }
        }

        for (const i of range) {
            if (prev !== undefined && i - prev > 1) {
                pages.push('...')
            }
            pages.push(i)
            prev = i
        }
        return pages
    }

    render() {
        const { logResults, isSearching, searchText, hasSearched, currentPage, totalCount } = this.state
        const totalPages = Math.ceil(totalCount / 50)
        return (
            <div style={{ textAlign: 'left' }}>
                <Toaster />
                <Break style={{ margin: '16px 0 12px 0' }}>Search Logs</Break>

                <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                        <Input
                            value={searchText}
                            onClick={val => this.setState({ searchText: val })}
                            onKeyDown={this.handleKeyDown}
                            label="Filter by action, file name, area name... (leave empty for all)"
                        />
                    </div>
                    <Button type="hover-bottom-left" onClick={this.handleSearch} disabled={isSearching}>Search</Button>
                </div>

                {isSearching && <div style={{ textAlign: 'center' }}><Spinner /></div>}
                {!isSearching && hasSearched && logResults.length === 0 && <p>No log entries found.</p>}
                {!isSearching && logResults.length > 0 &&
                    <>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left', padding: '4px 8px' }}>Login</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px' }}>Area</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px' }}>File</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px' }}>Date</th>
                                    <th style={{ textAlign: 'left', padding: '4px 8px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logResults.map((log, i) => (
                                    <tr key={i} className="searchContent">
                                        <td style={{ padding: '4px 8px' }}>{log.loginName}</td>
                                        <td style={{ padding: '4px 8px' }}>{log.areaName ? `${log.areaName} (#${log.areaId})` : `(#${log.areaId})`}</td>
                                        <td style={{ padding: '4px 8px' }}>{log.fileName}</td>
                                        <td style={{ padding: '4px 8px' }}>{new Date(log.dateTimeUnixMs).toLocaleString()}</td>
                                        <td style={{ padding: '4px 8px' }}>{log.action}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {totalPages > 1 &&
                            <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '2px', flexWrap: 'wrap' }}>
                                <button className="tblPageBtn" type="button" onClick={() => this.goToPage(0)} disabled={currentPage === 0}>&#171; First</button>
                                <button className="tblPageBtn" type="button" onClick={() => this.goToPage(currentPage - 1)} disabled={currentPage === 0}>&#8249; Prev</button>
                                {this.getPageButtons(currentPage, totalPages).map((item, i) =>
                                    item === '...'
                                        ? <span key={`ellipsis-${i}`} style={{ padding: '0 4px' }}>…</span>
                                        : <button
                                            key={item}
                                            className="tblPageBtn"
                                            type="button"
                                            style={{ fontWeight: currentPage === item ? 'bold' : 'normal' }}
                                            onClick={() => this.goToPage(item)}
                                          >
                                            {item + 1}
                                          </button>
                                )}
                                <button className="tblPageBtn" type="button" onClick={() => this.goToPage(currentPage + 1)} disabled={currentPage === totalPages - 1}>Next &#8250;</button>
                                <button className="tblPageBtn" type="button" onClick={() => this.goToPage(totalPages - 1)} disabled={currentPage === totalPages - 1}>Last &#187;</button>
                            </div>
                        }
                    </>
                }
            </div>
        )
    }
}

export default AdminSearchLogs
